import { TS_Hotel }             from '../TravelSeller/Models/TS_Hotel';
import { BookingItemInterface } from './BookingItemInterface';

export class Hotel extends TS_Hotel implements BookingItemInterface {}